












import { Component, Prop, Vue } from "vue-property-decorator";
import { TOOLBAR_OVERFLOW_PORTAL } from "@/utils/ToolbarContext";

@Component
export default class ToolbarOverflowItemComponent extends Vue {
  @Prop({ type: String, required: true })
  label!: string;

  @Prop({ type: Boolean, default: false })
  disabled!: boolean;

  /** Position in the menu; portal-vue sorts the items of one target by it. */
  @Prop({ type: Number, default: 0 })
  order!: number;

  portalName = TOOLBAR_OVERFLOW_PORTAL;
}
